module.exports = __webpack_public_path__ + "svg/logo-wijs-breda.svg";